/**
 * Branch (cabang) is a plain text column on both the user and the document, not
 * a lookup table — these are the only two values in use today.
 */
export const BRANCH_OPTIONS = [
  { value: 'JAKARTA', label: 'JAKARTA' },
  { value: 'SURABAYA', label: 'SURABAYA' },
];

/**
 * Sentinel the API understands as "every branch". Sending nothing means "my own
 * branch", which the server resolves from the session — so the two are distinct
 * states and an empty string must never be sent to mean "all".
 */
export const BRANCH_ALL = 'ALL';
